import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function DisclaimerPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("footerDisclaimer")}
              </h1>
            </div>

            <div className="space-y-8">
              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Independent Resource</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  This website is an independent informational resource and is not affiliated with, endorsed by, or sponsored by AllChinaBuy or any related entities. AllChinaBuy is a trademark of its respective owners. We provide educational content only and do not represent the company in any capacity.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">No Guarantees</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  We do not guarantee the accuracy, completeness, or reliability of any information on this website. Product availability, prices, seller information, shipping costs, and coupon codes may change without notice. Users should always verify information directly on the AllChinaBuy platform or with sellers before making purchasing decisions.
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  This website provides educational information and is not legal, financial, customs, or professional advice. We strongly recommend consulting with appropriate professionals for advice related to international trade, customs regulations, and import duties in your country.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">External Links</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  This website contains links to external websites, including kaspreadsheet.com. We are not responsible for the content, privacy practices, or security of external websites. Clicking external links is at your own risk. We recommend reviewing the terms and privacy policies of any external site before using their services.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Risk Acknowledgment</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  International shopping involves inherent risks including but not limited to: shipping delays, customs seizures, product defects, counterfeit goods, and payment disputes. By using the information on this website, you acknowledge that all purchasing decisions are made at your own risk and responsibility. We are not liable for any losses, damages, or issues arising from purchases made through third-party platforms or sellers.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-accent-50/50 border border-accent-200/50">
                <p className="text-sm text-foreground-700 leading-relaxed font-medium">
                  Last updated: August 25, 2026. This disclaimer may be updated periodically. Please review it regularly for any changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}